import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=42a51170&scoped=true"
import script from "./MessagePreview.vue?vue&type=script&lang=js"
export * from "./MessagePreview.vue?vue&type=script&lang=js"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=42a51170&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a51170",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a51170')) {
      api.createRecord('42a51170', component.options)
    } else {
      api.reload('42a51170', component.options)
    }
    module.hot.accept("./MessagePreview.vue?vue&type=template&id=42a51170&scoped=true", function () {
      api.rerender('42a51170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/previews/MessagePreview.vue"
export default component.exports